import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, RouteReuseStrategy, withComponentInputBinding } from '@angular/router';

import { provideHttpClient, withInterceptors, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { provideHotToastConfig } from '@ngxpert/hot-toast';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DndModule } from 'ngx-drag-drop';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { NgxSpinnerModule } from 'ngx-spinner';
import { routes } from './app.routes';
import { warehouseInterceptor } from './shared/interceptors/warehouse.interceptor';
import { ListRouteReuseStrategy } from './shared/strategies/list-route-reuse.strategy';
import { KeycloakService, KeycloakAngularModule, KeycloakBearerInterceptor } from 'keycloak-angular';
import { createKeycloakInitializer } from './shared/keycloak-init.factory';
import { authInterceptor } from './shared/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideEnvironmentNgxMask(),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([authInterceptor, warehouseInterceptor]),
      withInterceptorsFromDi()
    ),
    KeycloakAngularModule,
    importProvidersFrom([BrowserAnimationsModule, NgxSpinnerModule]),
    provideHotToastConfig({
      duration: 5000,
      dismissible: true,

      success: {
        style: {
          backgroundColor: '#28a745',
          color: '#fff',
          fontSize: '16px',
        },
      },
      error: {
        style: {
          backgroundColor: '#dc3545',
          color: '#fff',
          fontSize: '16px',
        },
      },
      warning: {
        style: {
          backgroundColor: '#ffc107',
          color: '#fff',
          fontSize: '16px',
        },
      },
    }),
    BsModalService,
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [BsModalService],
      useFactory: (bsModalService: BsModalService) => {
        return () => {
          bsModalService.config.animated = true;
          bsModalService.config.backdrop = 'static';
          bsModalService.config.focus = true;
          bsModalService.config.ignoreBackdropClick = true;
          bsModalService.config.keyboard = true;
        };
      },
    },
    importProvidersFrom(DndModule),
    KeycloakService,
    {
      provide: APP_INITIALIZER,
      useFactory: createKeycloakInitializer,
      multi: true,
      deps: [KeycloakService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakBearerInterceptor,
      multi: true,
    },
    { provide: RouteReuseStrategy, useClass: ListRouteReuseStrategy },
  ],
};
